/**
 * GraphQL Mutation: SignIn
 * Sign in user
 */
export const SIGN_IN = `
  mutation SignIn($email: String!, $password: String!) {
    signIn(email: $email, password: $password) {
      accessToken
      idToken
      expiresIn
      tokenType
    }
  }
`;
//# sourceMappingURL=signIn.js.map